import { useRef } from 'react';
import { useParams } from 'react-router-dom';

import SectionCard from '@/components/common/SectionCard/SectionCard';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import PartyHeaders from './components/ParentHeaders/PartyHeaders';

export default function ContractPartiesContainer() {
  const sectionCardRef = useRef<any>();
  const { contractId }: { contractId: UUID } = useParams();
  const { contract, isContractLoading } = useGetContractDetails(contractId);

  return (
    <div className="mb-20">
      <SectionCard
        ref={sectionCardRef}
        title={{
          titleText: 'Contract Parties',
        }}
        padding={true}
      >
        <PartyHeaders
          isLoadingContractDetails={isContractLoading}
          contract={contract}
        />
      </SectionCard>
    </div>
  );
}
